/**
 * 开发成vue插件使用echarts 
 */
//导入echarts 

import * as echarts from 'echarts'
import store from '../store/index'
//导入地图的js文件
// import 'echarts/map/js/china'
//导入世界的js文件
// import 'echarts/map/js/world'
//导入映射的翻译-世界国家名称
// import country from '../utils/country'
//导入城市的js 
// import '../request/mianyang.json'
// import '../utils/map'


const install = function (Vue, options) {
    // 添加实例方法 
    // Vue.prototype.demo=function(){}  //obj.name    
    //Vue.prototype.$myChart={demo(),fun(),...}
    Object.defineProperties(Vue.prototype, {
        $myChart: {
            get() {
                return {
                    //1. 国内专利申请趋势
                    line(id,data,data1) {
                        const myChart = echarts.init(document.getElementById(id));
                        // 指定图表的配置项和数据
                        const option = {
                          
                            tooltip: {
                                trigger: "axis",
                                axisPointer: {
                                    type: "line",

                                },
                            },
                            axisLabel: {
                                interval: 0  //设置间隔为0
                            },
                        
                            toolbox: {
                                feature: {
                                    saveAsImage: {
                                        title: false
                                    }
                                },
                                bottom: -5
                            },
                            legend: {
                                show: true,
                                icon: "rect",
                                top: "10px", //设置位置
                                left:"45%",
                                // 图例宽高
                                itemWidth: 10,
                                itemHeight: 10,
                                itemStyle: {
                                    // color: "#5B8FF9",
                                    fontSize: 12,
                                },

                            },
                            xAxis: {
                                type: "category",
                                
                                data:store.state.ptApplydataYagreeind
                                // data: ['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月'],
                            },
                            yAxis: {
                                type: "value",
                                axisLabel: {
                                    formatter: '{value} 件'
                                  }
                            },
                            grid: {
                                left: '3%',
                                right: '4%',
                                bottom: '3%',
                                containLabel: true
                              },
                            series: [
                                {
                                    name: "申请量",
                                    type: "line",
                                    // 数据的堆叠
                                    // stack: "num",
                                    data:store.state.ptApplydataYapplyind,
                                    
                                    // 样式填充
                                    // areaStyle:{},
                                    // 选中高亮状态
                                    emphasis: {
                                        focus: "series" //聚焦当前的区域高亮
                                    },
                                    lineStyle:{
                                        color:'#73A0FA'
                                }
                                    },
                                    {
                                        name: "授权量",
                                        type: "line",
                                        // 数据的堆叠
                                        // stack: "num",
                                        data: store.state.ptAuthorizationLine,
                                       
                                        // 样式填充
                                        // areaStyle:{},
                                        // 选中高亮状态
                                        emphasis: {
                                            focus: "series" //聚焦当前的区域高亮
                                        },
                                        lineStyle:{
                                            color:'#73deb3'
                                    }
                                        
                                },
                            ],
                        };
                        // 使用刚指定的配置项和数据显示图表。
                        myChart.setOption(option);
                    },
                    // 国内商标申请趋势
                    tmApply(id,data) {
                        const myChart = echarts.init(document.getElementById(id));
                        // 指定图表的配置项和数据
                        const option = {
                            title: {
                                // text: "国内专利申请/授权趋势",
                                textStyle: {
                                    fontSize: 14,
                                },
                            },
                            tooltip: {
                                trigger: "axis",
                                axisPointer: {
                                    type: "line"
                                },
                            },
                            axisLabel: {
                                interval: 0  //设置间隔为0
                            },
                            toolbox: {
                                feature: {
                                    saveAsImage: {
                                        title: false
                                    }
                                },
                                bottom: -5
                            },
                            legend: {
                                show: true,
                                icon: "rect",
                                top: "10px", //设置位置
                                left:"45%",
                                // 图例宽高
                                itemWidth: 10,
                                itemHeight: 10,
                                itemStyle: {
                                    // color: "#5B8FF9",
                                    fontSize: 12,
                                },

                            },
                            xAxis: {
                                type: "category",
                                data:store.state.tmApplyMonth
                                // data: ['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月'],
                            },
                            yAxis: {
                                type: "value",
                                axisLabel: {
                                    formatter: '{value} 件'
                                  }
                            },
                            grid: {
                                left: '3%',
                                right: '4%',
                                bottom: '3%',
                                containLabel: true
                              },
                            series: [
                                {
                                    name: "申请量",
                                    type: "line",
                                    // 数据的堆叠
                                    // stack: "num",
                                    data:store.state.tmApplyNum,
                                    
                                    // 样式填充
                                    // areaStyle:{},
                                    // 选中高亮状态
                                    emphasis: {
                                        focus: "series" //聚焦当前的区域高亮
                                    },
                                    lineStyle:{
                                        color:'#9bbbfb'
                                }
                                    },
                                    {
                                        name: "注册量",
                                        type: "line",
                                        // 数据的堆叠
                                        // stack: "num",
                                        data: store.state.tmRegNum,
                                       
                                        // 样式填充
                                        // areaStyle:{},
                                        // 选中高亮状态
                                        emphasis: {
                                            focus: "series" //聚焦当前的区域高亮
                                        },
                                        lineStyle:{
                                            color:'#73deb3'
                                    }
                                        
                                },
                            ],
                        };
                        // 使用刚指定的配置项和数据显示图表。
                        myChart.setOption(option);
                    },
                    // 2.获取绵阳地图
                    // getMap(id) {
                    //     const mCharts = echarts.init(document.getElementById(id))
                    //     const res = require('../assets/js/diagrams/mianyang.json')
                    //     // console.log('resmap',res)
                    //     echarts.registerMap('chinaMap', res)
                    //     const option = {
                    //         geo: {
                    //             type: 'map',
                    //             map: 'chinaMap',
                    //             roam: true,
                    //             zoom: 2,
                    //             // 设置中心点
                    //             // center:[116.38162,36.5787],
                    //             label: {
                    //                 show: true,
                    //                 // 显示文字颜色
                    //                 color: '#323232',
                    //                 fontSize: 12,
                    //             },
                    //             grid: {
                    //                 left: 10,
                    //                 containLabel: true,
                    //                 bottom: 10,
                    //                 top: 10,
                    //                 right: 30
                    //             },
                    //             // itemStyle: {
                                  
                    //             //     emphasis: { // 选中的区域颜色及阴影效果等
                    //             //         areaColor: '#1572D5',
                    //             //         shadowOffsetX: 0,
                    //             //         shadowOffsetY: 0,
                    //             //         shadowBlur: 20,
                    //             //         borderWidth: 0,
                    //             //     }
                    //             // },
                    //             emphasis: {
                    //                 // 地图颜色

                    //                 itemStyle: {
                    //                     show: true,
                    //                     color: '#fff',
                    //                     areaColor: '#1572D5', //鼠标滑过区域颜色
                    //                     label: {
                    //                         show: true,
                    //                         textStyle: {
                    //                             color: '#fff'
                    //                         }
                    //                     },
                    
                                        
                    //                 }
                    //             }
                    //         },
                    //         series: [{
                    //                 data: this.airDate,
                    //                 geoIndex: 0,
                    //                 type: 'map',
                    //             },

                    //         ],
                    //     }
                    //     mCharts.setOption(option)
                    //     let _this = this;
                    //     // mCharts.on('click',function(params){
                    //     //     console.log('params',params.name)
                    //     //     _this.$GET("/home/summary", {
                    //     //         cnty: params.name,
                    //     //       }).then((res) => {
                    //     //         console.log("--", res);
                    //     //       })
                    //     // })
                    //     // window.addEventListener('resize', () => {
                    //     //     mCharts.resize()
                    //     // })

                    // },
                    // 横向柱状图
                    getBarChart(id,data) {
                        const myChart = echarts.init(document.getElementById(id));
                        const option = {
                            tooltip: {
                                trigger: 'axis',
                                axisPointer: {
                                  type: 'shadow'
                                }
                              },
                              legend: {
                                show: true,
                                icon: "rect",
                                left:"70%",
                                top: "10px", //设置位置
                                // 图例宽高
                                itemWidth: 10,
                                itemHeight: 10,
                                itemStyle: {
                                    // color: "#5B8FF9",
                                    fontSize: 12,
                                },
                              },
                              grid: {
                                left: '3%',
                                right: '4%',
                                bottom: '3%',
                                containLabel: true
                              },
                              toolbox: {
                                feature: {
                                    saveAsImage: {
                                        title: false
                                    }
                                },
                                bottom: -5,
                                right: -5
                            },
                              xAxis: {
                                type: 'value',
                                boundaryGap: [0, 0.01],
                                axisLine: {
                                    show: true,
                                   
                                },
                                axisLabel: {
                                    show: false
                                },
                              },
                              yAxis: {
                                type: 'category',
                                data: store.state.tmIcApplyIc,
                                data: store.state.tmIcRegIc,
                                triggerEvent: true,
                              
                                axisLabel: {
                                    // color: "#000",
                                    formatter: function (params) {
                                        var val = ""
                                        if (params.length > 10) {
                                            val = params.substr(0, 10) + "..."
                                            return val
                                        } else {
                                            return params
                                        }
                                    }
                                },
                                inverse: true
                              },
                              series: [
                               
                                {
                                  name: '申请量',
                                  type: 'bar',
                                  data: store.state.tmIcApplyNum
                                },
                                {
                                    name: '注册量',
                                    type: 'bar',
                                    data: store.state.tmIcRegNum
                                  }
                              ]
                        };

                        option && myChart.setOption(option);
                        window.addEventListener('resize', () => {
                            myChart.resize()
                        })
                    },
                    //4. 城市地图
                    cityMap(id, cityname, data) {
                        var myChart = echarts.init(document.getElementById(id));
                        var option = {
                            tooltip: { //悬浮弹框
                                triggerOn: 'click', //提示框触发的条件
                                enterable: true,
                                formatter(data) { //[{} ] data={}
                                    return data.name
                                }
                            },
                            visualMap: [{ //映射高亮颜色
                                orient: "vertical", //垂直
                                type: "piecewise", //离散
                                bottom: 0,
                                pieces: [ // 配置颜色区间
                                    {
                                        min: 0,
                                        max: 0,
                                        color: "#FFFFFF"
                                    },
                                    {
                                        min: 1,
                                        max: 10,
                                        color: "#FDFDCF"
                                    },
                                    {
                                        min: 10,
                                        max: 100,
                                        color: "#FE9E83"
                                    },
                                    {
                                        min: 100,
                                        max: 500,
                                        color: "#E55A4E"
                                    },
                                    {
                                        min: 500,
                                        max: 10000,
                                        color: "#4F070D"
                                    }
                                ]
                            }],
                            series: [{
                                name: "市",
                                type: "map", //地图
                                map: cityname, //中国地图
                                roam: false,
                                zoom: 1.2,
                                aspectScale: 0.75,
                                top: 40,
                                layoutCenter: ['5%', '5%'],
                                label: {
                                    normal: {
                                        show: true,
                                        textStyle: {
                                            fontSize: 8
                                        }
                                    }
                                },
                                itemStyle: {
                                    normal: {
                                        areaColor: 'rgba(0,255,236,0)',
                                        borderColor: 'rgba(0,0,0,0.2)',
                                    },
                                    emphasis: { // 选中的区域颜色及阴影效果等
                                        areaColor: 'rgba(255,180,0,0.8)',
                                        shadowOffsetX: 0,
                                        shadowOffsetY: 0,
                                        shadowBlur: 20,
                                        borderWidth: 0,
                                    }
                                },
                                data
                            }]
                        }
                        myChart.setOption(option);
                    },
                }
            }
        }
    })

}

export default install